import React from "react";
import { Globe, Users, MapPin, Languages, DollarSign, Flag } from "lucide-react";

const CountryInfo = ({ country }) => {
  if (!country) return null;

  return (
    <div className="p-6 rounded-xl shadow-lg bg-white border border-gray-200">
      {/* Nom et drapeau */}
      <div className="flex items-center gap-4 mb-6">
        <img
          src={country.flags?.png}
          alt={country.flags?.alt || `Drapeau de ${country.name?.common}`}
          className="w-16 h-12 object-cover rounded shadow"
        />
        <h2 className="text-2xl font-bold text-gray-800">
          {country.name?.official || country.name?.common}
        </h2>
      </div>

      {/* Infos principales en grille */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
        <p className="flex items-center gap-2">
          <Flag className="w-5 h-5 text-blue-500" />
          <span><strong>Nom courant :</strong> {country.name?.common}</span>
        </p>
        <p className="flex items-center gap-2">
          <MapPin className="w-5 h-5 text-red-500" />
          <span><strong>Capitale :</strong> {country.capital?.[0]}</span>
        </p>
        <p className="flex items-center gap-2">
          <Users className="w-5 h-5 text-purple-500" />
          <span><strong>Population :</strong> {country.population?.toLocaleString()}</span>
        </p>
        <p className="flex items-center gap-2">
          <Globe className="w-5 h-5 text-green-600" />
          <span>
            <strong>Région :</strong> {country.region} ({country.subregion})
          </span>
        </p>
      </div>

      {/* Langues */}
      <div className="mt-4">
        <p className="flex items-center gap-2 mb-2">
          <Languages className="w-5 h-5 text-indigo-500" />
          <strong>Langues :</strong>
        </p>
        <div className="flex flex-wrap gap-2">
          {country.languages
            ? Object.values(country.languages).map((lang, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1 bg-gray-100 rounded-full text-sm shadow-sm"
                >
                  {lang}
                </span>
              ))
            : "N/A"}
        </div>
      </div>

      {/* Monnaies */}
      <div className="mt-4">
        <p className="flex items-center gap-2 mb-2">
          <DollarSign className="w-5 h-5 text-yellow-500" />
          <strong>Monnaie :</strong>
        </p>
        <div className="flex flex-wrap gap-2">
          {country.currencies
            ? Object.values(country.currencies).map((c, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm shadow-sm"
                >
                  {c.name} ({c.symbol})
                </span>
              ))
            : "N/A"}
        </div>
      </div>

      {/* Liens utiles */}
      <div className="mt-6 flex gap-3">
        <a
          href={country.maps?.googleMaps}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 shadow"
        >
          Voir sur Google Maps
        </a>
        <a
          href={country.maps?.openStreetMaps}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-medium hover:bg-green-700 shadow"
        >
          Voir sur OpenStreetMap
        </a>
      </div>
    </div>
  );
};

export default CountryInfo;
